import { Component } from '@angular/core';
import { FooterComponent } from '../../shared/footer/footer.component';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-payments',
  standalone: true,
  imports: [FooterComponent],
  templateUrl: './payments.component.html',
  styleUrl: './payments.component.scss'
})
export class PaymentsComponent {
  constructor(private titleService: Title, private meta: Meta,) {

    try {
      this.meta.removeTag('title');
      this.meta.removeTag('description');

      this.meta.removeTag('og:type');
      this.meta.removeTag('og:url');
      this.meta.removeTag('og:title');
      this.meta.removeTag('og:description');
      this.meta.removeTag('og:image');


      this.meta.removeTag('twitter:card');
      this.meta.removeTag('twitter:url');
      this.meta.removeTag('twitter:title');
      this.meta.removeTag('twitter:description');
      this.meta.removeTag('twitter:image');
      this.meta.removeTag('twitter:image');
    } catch (error) {

    }
    this.titleService.setTitle('Payment Details')
    this.meta.addTag({ name: 'title', content: 'Payment Details' });
    var g = 'ඔබ මුදල් ගෙවීමට පෙර අනිවාර්යයෙන් අවශ්‍ය භාණ්ඩය shop එකෙහි stock පවතී ද යන්න අප අමතා ස්ථීර කරගත යුතුය. Before you pay, you must contact us and confirm whether the required product is in stock in the shop. Call Now: 077 (255) 3478. Trusted warranty & support    ';
    this.meta.addTag({ name: 'description', content: g });

    this.meta.addTag({ property: 'og:type', content: 'website' });
    this.meta.addTag({ property: 'og:url', content: 'https://softnetcomputers.lk' + '/payment-details' });
    this.meta.addTag({ property: 'og:title', content: 'Payment Details' });
    this.meta.addTag({ name: 'og:description', content: g }); 
    this.meta.addTag({ property: 'twitter:url', content: 'https://softnetcomputers.lk' + '/payment-details' });
    this.meta.addTag({ property: 'twitter:title', content: 'Payment Details' });
    this.meta.addTag({ name: 'twitter:description', content: g });


  }

}
